import { Component, OnInit } from '@angular/core';

import { ActivatedRoute, Router } from '@angular/router';

import { TeamBalanceDetailsSearchHandler } from './team-balance-details-search.handler';

import { HeaderService } from 'src/app/system-common/services/header.service';
import { SettingService } from 'src/app/system-common/services/setting.service';
import { FinanceService } from '../services/finance.service';

@Component({
  selector: 'sym-balance-details-search',
  templateUrl: './team-balance-details-search.component.html',
  styleUrls: ['./team-balance-details-search.component.scss'],
})
export class TeamBalanceDetailsSearchComponent extends TeamBalanceDetailsSearchHandler implements OnInit {
  constructor(
    public service: FinanceService,
    public headerService: HeaderService,
    public router: Router,
    public settingService: SettingService,
    public route: ActivatedRoute
  ) {
    super(service, headerService, router, settingService, route);
  }

  ngOnInit() {
    super.ngOnInit();
  }
}
